<template>
  <form class="form-inline my-2 my-lg-0 search-form" @submit.prevent="search">
    <label class="sr-only" :for="inputId">Search for a movie or TV series</label>
    <input
      :id="inputId"
      class="form-control mr-sm-2 search-box"
      type="search"
      placeholder="Movie or TV series title"
      aria-label="Search for a movie or TV series"
      :aria-describedby="validationMessage ? messageId : undefined"
      name="searchQuery"
      v-model="searchQuery" />
    <button type="submit" class="btn btn-yellow btn-nav my-2 my-sm-0 search-button" :disabled="isBusy" aria-label="Search for titles">
      <i v-if="isBusy" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
      <i class="fa fa-search" aria-hidden="true"></i>
      <span>{{ isBusy ? "Searching…" : "Search" }}</span>
    </button>
    <small v-if="validationMessage" :id="messageId" class="search-message" role="status">
      {{ validationMessage }}
    </small>
  </form>
</template>

<script>
let nextSearchId = 0;

export default {
  name: "ItemSearch",
  props: {
    listId: String,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchQuery: this.$route.query.query || "",
      submitting: false,
      validationMessage: "",
      searchId: ++nextSearchId,
    };
  },
  computed: {
    isBusy() {
      return this.loading || this.submitting;
    },
    inputId() {
      return "title-search-" + this.searchId;
    },
    messageId() {
      return this.inputId + "-message";
    },
  },
  watch: {
    "$route.query.query"(query) {
      this.searchQuery = query || "";
      this.submitting = false;
    },
    loading(value) {
      if (!value) this.submitting = false;
    },
  },
  methods: {
    search() {
      if (this.isBusy) return;

      const query = this.searchQuery.trim();
      this.searchQuery = query;

      if (!query) {
        this.validationMessage = "Enter a title to search.";
        return;
      }

      this.validationMessage = "";
      this.submitting = true;
      Promise.resolve(this.$router.replace({ path: "/items", query: { listId: this.listId, query } })).finally(() => {
        if (!this.loading) this.submitting = false;
      });
    },
  },
};
</script>

<style scoped>
.search-form {
  align-items: flex-start;
}

.search-button {
  align-items: center;
  display: inline-flex;
  gap: 7px;
  justify-content: center;
}

.search-message {
  color: #fff3cd;
  flex-basis: 100%;
  margin-top: 4px;
}

/* Responsive layout - makes a one column layout instead of a two-column layout */
@media (max-width: 800px) {
}

/* Medium devices (tablets, less than 992px) */
@media (max-width: 991.98px) {
}

/* Small devices (landscape phones, less than 768px) */
@media (max-width: 767.98px) {
}

/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
  .search-form,
  .search-box,
  .search-button {
    width: 100%;
  }

  .search-box {
    margin-right: 0 !important;
  }
}

/* Large devices (desktops, less than 1200px) */
@media (max-width: 1199.98px) {
}
</style>
